import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { format } from 'date-fns';

@Component({
    selector: 'calendar-month',
    template: `
        <span
            class="month-container"
            (click)="monthClick.emit($event)"
            [ngClass]="monthContainerClassList"
        >
            <span class="month-inner" [ngClass]="monthInnerClassList">
                {{ format(date, 'MMM') }}
            </span>
        </span>
    `,
    styleUrls: ['./calendar-month.component.scss']
})
export class CalendarMonthComponent implements OnChanges {
    @Input() public date: Date;
    @Input() public disabled: boolean;
    @Input() public isStartOfRange: boolean;
    @Input() public isEndOfRange: boolean;
    @Input() public withinRange: boolean;
    @Input() public isToday: boolean;
    @Input() public selected: boolean;
    @Output() public monthClick = new EventEmitter<Event>();
    public monthContainerClassList: string[] = [];
    public monthInnerClassList: string[] = [];
    public format = format;

    public ngOnChanges(): void {
        this.setClassList();
    }

    public setClassList(): void {
        this._setCssClass('selected', this.selected);
        this._setCssClass('start-of-range', this.isStartOfRange);
        this._setCssClass('within-range', this.withinRange);
        this._setCssClass('end-of-range', this.isEndOfRange);
        this._setCssClass('disabled', this.disabled);
        this._setCssClass('today', this.isToday);
        this._setCssClass('start-of-row', this._isStartOfRow());
        this._setCssClass('end-of-row', this._isEndOfRow());
    }

    private _getMonthInnerClassName(className: string): string {
        return `month-inner-${className}`;
    }

    private _setCssClass(className: string, condition: boolean): void {
        const monthInnerClassName = this._getMonthInnerClassName(className);
        const monthContainerIndex = this.monthContainerClassList.indexOf(className);
        const monthInnerIndex = this.monthInnerClassList.indexOf(monthInnerClassName);
        if (condition) {
            if (monthContainerIndex === -1) {
                this.monthContainerClassList.push(className);
            }
            if (monthInnerIndex === -1) {
                this.monthInnerClassList.push(monthInnerClassName);
            }
        } else {
            if (monthContainerIndex > -1) {
                this.monthContainerClassList.splice(monthContainerIndex, 1);
            }
            if (monthInnerIndex > -1) {
                this.monthInnerClassList.splice(monthInnerIndex, 1);
            }
        }
    }

    private _isStartOfRow(): boolean {
        return (
            this.date &&
            !!this.date
                .getMonth()
                .toString()
                .match(/^[0369]{1}$/)
        );
    }

    private _isEndOfRow(): boolean {
        return (
            this.date &&
            !!this.date
                .getMonth()
                .toString()
                .match(/^([258]{1}|11)$/)
        );
    }
}
